import { defineComponent as n, computed as o, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "528801b6-f885-47fc-a091-b59d68c790ba" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#528801b6-f885-47fc-a091-b59d68c790ba)" }, k = { key: 0 }, p = /* @__PURE__ */ t("path", {
  fill: "#ffda44",
  d: "m0 256 258-39.4L512 256v256H0z"
}, null, -1), v = /* @__PURE__ */ t("path", {
  fill: "#338af3",
  d: "M0 0h512v256H0z"
}, null, -1), g = { fill: "none" }, x = ["r"], W = /* @__PURE__ */ n({
  __name: "ua",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), a = o(() => 256 + e.strokeWidth / 2);
    return (w, b) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (c(), i("title", k, d(e.flagName), 1)) : f("", !0),
        p,
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: _({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  W as default
};
//# sourceMappingURL=ua-4073e811.js.map
